import Volume from './Volume';

export default class VolumeGroup extends Volume {}
